import { useAuthenticate } from "./bootAuth";
import { Header, Page } from "./components";
import { Schedule } from "./Schedule";
import { Maintenance } from "./Maintenance";
import { createPortal } from "react-dom";
import { GeneralDisclaimer } from "./Disclaimer";
import { useEffect, useState } from "react";
import { SettingsDropdown } from "./SettingsDropdown";
import { Banner } from "./Banner";
import { RinkBadge } from "./RinkBadge";

const inMaintenance = false;
function App() {
  useAuthenticate();
  const [pageElement, setPageElement] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setPageElement(document.getElementById("page"));
  }, []);

  if (inMaintenance) {
    return (
      <Page>
        <Maintenance />
      </Page>
    );
  }

  return (
    <Page>
      {pageElement && createPortal(<GeneralDisclaimer />, pageElement)}
      <Banner />
      <Header subtitle={<RinkBadge />} right={<SettingsDropdown />} />
      <Schedule />
    </Page>
  );
}

export default App;
